import NotificationsContainer from './containers/NotificationsContainer';

export default NotificationsContainer;
